export const TABLE_CLASS_NAME = 'table';
export const HEADER_COLUMN_CLASS_NAME = `${TABLE_CLASS_NAME}__th`;
export const COLUMN_CLASS_NAME = `${TABLE_CLASS_NAME}__td`;
export const ROW_CLASS_NAME = `${TABLE_CLASS_NAME}__tr`;
